import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyUserSettingsComponent } from './myusersettings.component';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { PCPCommonModule } from '../../../../pcpcommon.module';
import { PcpCommandBarModule } from '../../../pcpcommandbar/pcp-commandbar.module';



@NgModule({
    imports: [
        CommonModule,        
        FormsModule,
        ToggleSwitchModule,
        PcpCommandBarModule,
        PCPCommonModule,
        TableModule,
        MyUserSettingsComponent
    ],
    exports: [MyUserSettingsComponent]
})
export class MyUserSettingsModule { }
